import prawnKottu from './Kottu/prawnkottu.png'
import cheeseKottu from './Kottu/Cheese Kottu.png'
import chickenKottu from './Kottu/Chicken Kottu.png'
import fusionSpecialKottu from './Kottu/Fusion Special Kottu.png'

let kottuItems = [
    {
        item_id: "19",
        item_name: "Cheese Kottu",
        item_image: cheeseKottu,
        item_price: "1950",
        item_category: "kottu",
      },
      {
        item_id: "20",
        item_name: "Fusion Special Kottu",
        item_image: fusionSpecialKottu ,
        item_price: "2350",
        item_category: "kottu",
      },
      {
        item_id: "21",
        item_name: "Prawn Kottu",
        item_image: prawnKottu,
        item_price: "1750",
        item_category: "kottu",
      },
      {
        item_id: "22",
        item_name: "Chicken Kottu",
        item_image: chickenKottu ,
        item_price: "2150",
        item_category: "kottu",
      },
]

export default kottuItems